import { REFDATA_MAP } from '@/constants'
import _ from 'lodash'

function refData(data) {
  let normalised = {}

  //divider for dropdown list
  let divider = {
    value: null,
    text: '---------------------------------',
    disabled: true
  }

  if (!Array.isArray(data)) return normalised

  // Remap from retrieved API key/vals to PI key/vals
  data.forEach(parent => {
    normalised[parent.name] = parent.data.map(child => ({
      text: child.value,
      value: child.code
    }))
  })

  //language dropdown list - combine the languages with the popular languages, placeholder and divider
  let languagesPopular = normalised[REFDATA_MAP.LANGUAGES_POPULAR]
  let allLanguages = normalised[REFDATA_MAP.LANGUAGES]
  normalised[REFDATA_MAP.LANGUAGES] = languagesPopular
    .concat([divider], allLanguages)
    .filter(l => l.value !== 'XXX' && l.value !== 'YYY')  

  return normalised
}



export default {
  refData
}
